import { useEffect, useState } from 'react';
import PATH from 'crono-fe-common/constants/path';
import IconSWarning from 'crono-fe-common/icons/Icon-S-Warning';
import { Typography } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import { MainButton } from 'crono-fe-common/components/CronoButton';
import { useNavigate } from 'react-router-dom';
import { NotEnoughCreditsWrapper } from './style';

interface NotEnoughCreditsBadgeProps {
  usagePlace:
    | 'find new'
    | 'list contacts'
    | 'list companies'
    | 'ai automations';
  notEnoughPhoneCredits?: boolean;
  notEnoughEmailCredits?: boolean;
  notEnoughAICredits?: boolean;
  notEnoughLinkedInCredits?: boolean;
  notEnoughEnrichmentCredits?: boolean;
}

const NotEnoughCreditsBadge = ({
  usagePlace,
  notEnoughPhoneCredits,
  notEnoughEmailCredits,
  notEnoughLinkedInCredits,
  notEnoughAICredits,
  notEnoughEnrichmentCredits, //used for company list
}: NotEnoughCreditsBadgeProps) => {
  const [showError, setShowError] = useState<boolean>(false);
  const [errorTitle, setErrorTitle] = useState<string>('');
  const [errorText, setErrorText] = useState<string>('');

  useEffect(() => {
    const requiredEntities = [];

    if (usagePlace === 'ai automations') {
      setErrorTitle('Not enough AI credits');

      if (notEnoughAICredits) {
        setShowError(true);
      }
    } else if (usagePlace === 'list companies') {
      if (notEnoughEnrichmentCredits && notEnoughAICredits) {
        setErrorTitle(
          'You do not have enough credits to enrich company information or use AI fields',
        );
        setShowError(true);
      } else if (notEnoughEnrichmentCredits) {
        setErrorTitle(
          'You do not have enough credits to enrich company information',
        );
        setShowError(true);
      } else if (notEnoughAICredits) {
        setErrorTitle('Not enough AI credits');
        setShowError(true);
      }
    } else {
      setErrorTitle('You do not have enough credits to find:');
    }

    if (usagePlace === 'find new' || usagePlace === 'list contacts') {
      if (notEnoughPhoneCredits) {
        requiredEntities.push('phone numbers');
        setShowError(true);
      }
      if (notEnoughEmailCredits || notEnoughLinkedInCredits) {
        requiredEntities.push('emails & LinkedIn URLs');
        setShowError(true);
      }
      if (notEnoughAICredits) {
        requiredEntities.push('AI fields');
        setShowError(true);
      }
    }

    setErrorText(requiredEntities.join(' | '));
  }, [
    notEnoughPhoneCredits,
    notEnoughEmailCredits,
    notEnoughLinkedInCredits,
    notEnoughAICredits,
    notEnoughEnrichmentCredits,
  ]);

  const navigate = useNavigate();

  const handleBuyMoreCredits = () => {
    navigate(PATH.SETTINGS.ADD_ONS);
  };

  return showError ? (
    <NotEnoughCreditsWrapper>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <IconSWarning color={colors.inactiveHover} />

        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography
            fontSize={12}
            lineHeight={'16px'}
            fontWeight={500}
            width={usagePlace === 'list companies' ? 260 : 'auto'}
          >
            {/* for company list and ai automations the title is enough */}
            {errorTitle}
          </Typography>

          {(usagePlace === 'find new' || usagePlace === 'list contacts') && (
            <Typography fontSize={12} lineHeight={'16px'} fontWeight={500}>
              {errorText}
            </Typography>
          )}
        </div>
      </div>

      <MainButton
        className="buy-button"
        width="72px"
        height="32px"
        fontSize="14px"
        style={{ background: colors.inactiveHover }}
        onClick={handleBuyMoreCredits}
      >
        Buy
      </MainButton>
    </NotEnoughCreditsWrapper>
  ) : null;
};

export { NotEnoughCreditsBadge };
